import { css } from '@emotion/react'

export const ImportMDStyle = css`

    margin-bottom: 15px;

`